export enum ViewMode {
  ALL = 'ALL',
  OWN = 'OWN',
  ARCHIVED = 'ARCHIVED'
}
